import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigProvider } from 'antd';
import { themeProps } from './themeProps';
function uiTheme({ children }) {
    return _jsx(ConfigProvider, { theme: themeProps, children: children });
}
export default uiTheme;
//# sourceMappingURL=uiTheme.js.map